import React from 'react';

import { CaretDownFilled, CaretUpFilled } from '@ant-design/icons';

import { SORT_ORDER } from '../../../constants';

type Props = {
  sortOrder: any;
};

const ShopRequestSortIcon = ({ sortOrder }: Props) => {
  if (sortOrder === SORT_ORDER.ASCEND) {
    return <CaretUpFilled />;
  } else if (sortOrder === SORT_ORDER.DESCEND) {
    return <CaretDownFilled />;
  }
  return <div />;
};

export default ShopRequestSortIcon;
